import { render, staticRenderFns } from "./CannedTextField.vue?vue&type=template&id=0460e907"
import script from "./CannedTextField.vue?vue&type=script&lang=js"
export * from "./CannedTextField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports